'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSortedChildrenInSection = exports.sortByModified = exports.sortByScore = exports.getChildrenInSection = exports.getSharingContext = exports.getClosestUpBoardId = exports.getClosestUpOfType = exports.getClosestAncestorBoardId = exports.getClosestAncestorOfType = exports.getPhysicalChildIdsDeep = exports.getChildIdsDeep = exports.getChildrenDeep = exports.getParent = exports.getChildren = exports.getElement = exports.getElementId = exports.isElementRealContent = exports.isElementCreatedByUser = exports.isInList = exports.isElementLocked = exports.filterOutLinkedBoards = exports.getPhysicalId = exports.isLocationInbox = exports.isLocationCanvas = exports.isLocationTrash = exports.isLocationInSection = exports.getLocationPosition = exports.getLocationParentId = exports.getLocationSection = exports.isContent = exports.isContainer = exports.isBoardLike = exports.isImage = exports.isLine = exports.isBoard = exports.isAlias = exports.isColumn = exports.isLink = exports.isCard = exports.isSkeleton = undefined;

var _lodash = require('lodash');

var _immutableHelper = require('../utils/immutableHelper');

var _aliasConstants = require('../alias/aliasConstants');

var _boardConstants = require('../boards/boardConstants');

var _columnConstants = require('../columns/columnConstants');

var _cardConstants = require('../cards/cardConstants');

var _linkConstants = require('../links/linkConstants');

var _lineConstants = require('../lines/lineConstants');

var _elementConstants = require('./elementConstants');

var _imageConstants = require('../images/imageConstants');

var _userConstants = require('../users/userConstants');

// Element Type functions


// Utils
var isType = function isType(type) {
    return function (elementType) {
        return (0, _lodash.isString)(elementType) ? elementType === type : (0, _immutableHelper.prop)('elementType', elementType) === type;
    };
};

// Constants
// Lib
var isSkeleton = exports.isSkeleton = isType(_elementConstants.SKELETON_ELEMENT_TYPE);
var isCard = exports.isCard = isType(_cardConstants.CARD_TYPE);
var isLink = exports.isLink = isType(_linkConstants.LINK_TYPE);
var isColumn = exports.isColumn = isType(_columnConstants.COLUMN_TYPE);
var isAlias = exports.isAlias = isType(_aliasConstants.ALIAS_TYPE);
var isBoard = exports.isBoard = isType(_boardConstants.BOARD_TYPE);
var isLine = exports.isLine = isType(_lineConstants.LINE_TYPE);
var isImage = exports.isImage = isType(_imageConstants.IMAGE_TYPE);

var isBoardLike = exports.isBoardLike = function isBoardLike(elementType) {
    return isBoard(elementType) || isAlias(elementType);
};

var isContainer = exports.isContainer = function isContainer(elementType) {
    return isBoard(elementType) || isAlias(elementType) || isColumn(elementType);
};

var isContent = exports.isContent = function isContent(elementType) {
    return !isLine(elementType) && !isContainer(elementType);
};

// Element location utils
var getLocationSection = exports.getLocationSection = (0, _immutableHelper.propIn)(['location', 'section']);
var getLocationParentId = exports.getLocationParentId = (0, _immutableHelper.propIn)(['location', 'parentId']);
var getLocationPosition = exports.getLocationPosition = (0, _immutableHelper.propIn)(['location', 'position']);

var isLocationInSection = exports.isLocationInSection = function isLocationInSection(section) {
    return function (element) {
        return getLocationSection(element) === section;
    };
};

var isLocationTrash = exports.isLocationTrash = isLocationInSection(_boardConstants.BOARD_SECTIONS.TRASH);
var isLocationCanvas = exports.isLocationCanvas = isLocationInSection(_boardConstants.BOARD_SECTIONS.CANVAS);
var isLocationInbox = exports.isLocationInbox = isLocationInSection(_boardConstants.BOARD_SECTIONS.INBOX);

// Element data retrieval functions
var getPhysicalId = exports.getPhysicalId = function getPhysicalId(element) {
    return isAlias(element) ? (0, _immutableHelper.propIn)(['content', 'linkTo'], element) : (0, _immutableHelper.prop)('id', element);
};

var filterOutLinkedBoards = exports.filterOutLinkedBoards = function filterOutLinkedBoards(elements) {
    var linkedBoardIds = elements.filter(isAlias).map(function (alias) {
        return alias.getIn(['content', 'linkTo']);
    });
    return elements.filter(function (selectedElement) {
        return linkedBoardIds.indexOf(selectedElement.get('id')) === -1;
    });
};

var isElementLocked = exports.isElementLocked = function isElementLocked(element) {
    return element && element.getIn(['content', 'locked']);
};

// TODO Review - is there a better way to do this?
var isInList = exports.isInList = function isInList(element) {
    return (0, _immutableHelper.propIn)(['location', 'section'], element) === _boardConstants.BOARD_SECTIONS.INBOX;
};

var isElementCreatedByUser = exports.isElementCreatedByUser = function isElementCreatedByUser(userId) {
    return function (element) {
        return (0, _immutableHelper.propIn)(['meta', 'creator'], element) === userId;
    };
};
var isElementRealContent = exports.isElementRealContent = function isElementRealContent(element) {
    return !isElementCreatedByUser(_userConstants.STARTER_CONTENT_CREATOR_ID)(element);
};

// Element retrieval functions
var getId = (0, _immutableHelper.prop)('id');
var getUnderscoreId = (0, _immutableHelper.prop)('_id');

var getElementId = exports.getElementId = function getElementId(element) {
    return element && getId(element) || getUnderscoreId(element);
};

var getElement = exports.getElement = function getElement(elementList, elementId) {
    return elementList.get(elementId);
};

var getChildren = exports.getChildren = function getChildren(elementList, parentId) {
    return elementList.filter(function (el) {
        return el.get('id') && el.getIn(['location', 'parentId']) === parentId;
    });
};

var getParent = exports.getParent = function getParent(elementList, element) {
    return elementList.get(element.getIn(['location', 'parentId']));
};

/**
 * Gets the 'deep' children of an element, meaning that children of columns will also be retrieved.
 * This is important because the elements displayed on the canvas will be direct children and children of columns.
 */
var getChildrenDeep = exports.getChildrenDeep = function getChildrenDeep(elementList, parentId) {
    return elementList.filter(function (el) {
        var elParentId = el.getIn(['location', 'parentId']);
        // If the elements parent ID equals the expected parent ID this element is a child
        if (elParentId && elParentId === parentId) return true;

        // If the parent is a column and its parent ID is the expected parent ID this element is a deep child
        return isColumn(elementList.getIn([elParentId, 'elementType'])) && elementList.getIn([elParentId, 'location', 'parentId']) === parentId;
    });
};

var getChildIdsDeep = exports.getChildIdsDeep = (0, _lodash.flow)([getChildrenDeep, _immutableHelper.toIdArray]);

/**
 * Similar to #getChildIdsDeep however this will replace aliases with the physical boards they link to.
 * This is used to help determine which socket channels should be connected to.
 */
var getPhysicalChildIdsDeep = exports.getPhysicalChildIdsDeep = function getPhysicalChildIdsDeep(elementList, parentId) {
    return getChildrenDeep(elementList, parentId).map(getPhysicalId).toSeq().toArray();
};

/**
 * Finds the first ancestor or itself that matches a predicateFn.
 */
var searchUp = function searchUp(predicateFn) {
    return function (elements, elementId) {
        // Iterate up the ancestor tree until we find an element which matches the predicate
        var element = elements.get(elementId);
        while (element && element.getIn(['location', 'parentId']) && !predicateFn(element, elements, elementId)) {
            element = elements.get(element.getIn(['location', 'parentId']));
        }
        return element && element.get('id');
    };
};

/**
 * Finds the closest ancestor of a specific type.
 */
var getClosestAncestorOfType = exports.getClosestAncestorOfType = function getClosestAncestorOfType(elementType) {
    return searchUp(function (element, elements, startingElementId) {
        return element.get('elementType') === elementType && element.get('id') !== startingElementId;
    });
};

/**
 * Finds the closest ancestor that's a board.
 */
var getClosestAncestorBoardId = exports.getClosestAncestorBoardId = getClosestAncestorOfType(_boardConstants.BOARD_TYPE);

/**
 * Finds the closest element up of a specific type (including self).
 */
var getClosestUpOfType = exports.getClosestUpOfType = function getClosestUpOfType(elementType) {
    return searchUp(function (element, elements, startingElementId) {
        return element.get('elementType') === elementType;
    });
};

/**
 * Finds the closest element up (including self) that's a board.
 */
var getClosestUpBoardId = exports.getClosestUpBoardId = getClosestUpOfType(_boardConstants.BOARD_TYPE);

/**
 * Finds the closest ancestor element (including itself) which is 'shared' (has an acl).
 * This will be the ID of the channel to send actions to.
 *
 * @return {String} The ID of the sharing context (the element ID of the closest shared ancestor).
 */
var getSharingContext = exports.getSharingContext = searchUp(function (element) {
    return element.get('acl');
});

var getChildrenInSection = exports.getChildrenInSection = function getChildrenInSection(elementList, section) {
    return elementList.filter(function (el) {
        return el.getIn(['location', 'section']) === section;
    });
};

var sortByScore = exports.sortByScore = function sortByScore(elementA, elementB) {
    return elementA.getIn(['location', 'position', 'score']) - elementB.getIn(['location', 'position', 'score']);
};

var sortByModified = exports.sortByModified = function sortByModified(elementA, elementB) {
    return (elementA.getIn(['meta', 'modifiedTime']) || 0) - (elementB.getIn(['meta', 'modifiedTime']) || 0);
};

var getSortedChildrenInSection = exports.getSortedChildrenInSection = function getSortedChildrenInSection(elementList, section, parentId, sortFn) {
    var childElements = parentId ? getChildren(elementList, parentId) : elementList;
    return getChildrenInSection(childElements, section).toList().sort(sortFn || sortByScore);
};


//////////////////
// WEBPACK FOOTER
// ./src/common/elements/elementHelper.js
// module id = 13
// module chunks = 0